
export default class DeviceUtils {

    static isTablet() {
        if (typeof window == "undefined") {
            return false;
        }
        
        return window.matchMedia('(min-width: 768px)').matches && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    static isMobile() {
        if (typeof window == "undefined") {
            return false;
        }

        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    static isiPhone() {
        if (typeof window == "undefined") {
            return false;
        }

        return /iPhone/i.test(navigator.userAgent);
    }

    static isiPad() {
        if (typeof window == "undefined") {
            return false;
        }

        return /iPad/i.test(navigator.userAgent);
    }

    static isiOS() {
        if (typeof window == "undefined") {
            return false;
        }

        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent?.includes("Mac") && "ontouchend" in document);
    }

    static isAndroid() {
        if (typeof window == "undefined") {
            return false;
        }
        
        return /Android/i.test(navigator.userAgent);
    }
}
